import axios from 'axios';
import { ApiError } from './error';

// "What's new" dialog. The catalogue lives in the backend so the web portal and
// the guide app read the same list; `surface` picks this portal's entries.
const url = '/api/v1/whats-new';

// mode 'new' (default): only what is new since the user last closed the dialog.
// mode 'all': every released entry, new ones flagged (the ? menu).
// since: replaces the stored cut-off for this one request (demo/console use).
export const fetchWhatsNew = ({ mode, since } = {}) =>
  axios
    .get(url, {
      params: {
        surface: 'web',
        ...(mode === 'all' ? { mode: 'all' } : {}),
        ...(since ? { since } : {})
      }
    })
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);

export const markWhatsNewSeen = () =>
  axios
    .post(`${url}/seen`, { surface: 'web' })
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
